<app-timeline-detail [timeline]="timelineItems"></app-timeline-detail>